<template>
	<div>
		<div class="shadow rounded pl-4 pr-4 pt-1 pb-4">

			<div class="row">
				<div class="col-md-5 col-12 mt-3">
					<h4>Target Sales Kecamatan</h4>
					<h6>Choose 1 Dealer To Use This Feature</h6>
				</div>
				<div class="col-md-7 mt-1">
					<div class="row">
						<div class="col" style="padding: 15px 0px 5px 0px">
							<button 
								type="button" 
								class="btn w-100" 
								style="border-radius: 10px 0px 0px 10px"
								:class="{'btn-primary' : selectedType == 'Kecamatan' , 'btn-outline-primary' : selectedType != 'Kecamatan'}" 
								@click="selectedType = 'Kecamatan'"
							>
								Area
							</button>
						</div>
						<div class="col" style="padding: 15px 0px 5px 0px">
							<button 
								type="button" 
								class="btn w-100" 
								:class="{'btn-primary' : selectedType == 'Dealer' , 'btn-outline-primary' : selectedType != 'Dealer'}" 
								@click="selectedType = 'Dealer'" 
								style="border-radius: 0px 10px 10px 0px"
							>
								Dealer
							</button>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				
				<div class="offset-md-3 col-md-3 col-6 wrapHighlight" v-if="selectedType == 'Dealer'">
					<Multiselect 
						:options="filterData.dealer.map(x => x.code)"
						:custom-label="opt => filterData.dealer.find(x => x.code == opt).name"
						placeholder="Select Dealer"
						:allow-empty="true"
						v-model="filter.dealer"
					/>
				</div>
				<div class="col-md-3 col-6 wrapHighlight" v-if="selectedType == 'Kecamatan'">
					<Multiselect 
						:options="filterData.kabupaten.map(x => x.kodekotakab)"
						:custom-label="opt => filterData.kabupaten.find(x => x.kodekotakab == opt).kotakab"

						placeholder="Select Kabupaten"
						:allow-empty="true"
						v-model="filter.kabupaten"
					/>
				</div>
				<div class="col-md-3 col-6 wrapHighlight" v-if="selectedType == 'Kecamatan'">
					<Multiselect 
						:options="filterData.area.map(x => x.kodekecamatan)"
						:custom-label="opt => filterData.area.find(x => x.kodekecamatan == opt).nama_kecamatan"
						:disabled="!filter.kabupaten"
						placeholder="Select Area"
						:allow-empty="true"
						v-model="filter.kecamatan"
					/>
				</div>
				<div class="col-md-4 col-6 ">
					<div class="block w-100 datePickerMCD">
						<!-- <DatePicker
							class="w-100"
							v-model="selected.date"
							type="month"
							style="height:46px">
						</DatePicker> -->
						<DatePicker 
							class="w-100 text-center"
							v-model="selected.date"
							type="monthrange"
							align="right"
							unlink-panels
							range-separator="To"
							start-placeholder="Start month"
							end-placeholder="End month"
							:picker-options="pickerOptions"
						/>
					</div>

				</div>
				<div class="col-md-2 col-3">
					<button class="btn w-100 border border-secondary" @click="exportExcel" style="height:40px;">Download CSV <i class="fa fa-download"></i></button>
				</div>
			</div>

			<DealerMCDReport 
				:filter="filter"
				ref="dealerMcd"
				v-if="selectedType == 'Dealer'"
				:selected="selected"
			/>

			<KecamatanMCdReport 
				v-else
				:filter="filter"
				ref="kecamatanMcd"
			/>
		</div>

	</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
const XLSX = require('xlsx')
import moment from 'moment'
import { DatePicker } from 'element-ui'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

import DealerMCDReport from './DealerMCDReport.vue'
import KecamatanMCdReport from './KecamatanMCDReport.vue'

locale.use(lang)

export default {
	components : {
		Multiselect,
		DatePicker,
		DealerMCDReport,
		KecamatanMCdReport
	},
	data () {
		let now = new moment()
		let start = new moment().startOf('month').format('YYYY-MM-DD')
		let end = new moment().endOf('month').format('YYYY-MM-DD')


		return {
			 pickerOptions: {
				shortcuts: [{
					text: 'This month',
					onClick(picker) {
						picker.$emit('pick', [new Date(), new Date()]);
					}	
				}, {
					text: 'This year',
					onClick(picker) {
					const end = new Date();
					const start = new Date(new Date().getFullYear(), 0);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last 6 months',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setMonth(start.getMonth() - 6);
						picker.$emit('pick', [start, end]);
					}
				}]
			},

			modal : {
				uploadTarget : false,
				modifyModal : false
			},
			modalData : null,
			filter : {
				dealer : null,
				start : start,
				end : end,
				kecamatan : null,
				kabupaten : null
			},
			filterData : {
				dealer : this.$store.getters.getDealer(null , null),
				area : [],
				kabupaten : []
			},
			selected : {
				date : [
					new moment().startOf('month').toISOString() , new moment().endOf('month').toISOString()
				]
			},
			reportData : null,
			summaryData : null,
			selectedType : 'Kecamatan'
		}
	},
	watch : {
		'selected.date' : function () {
			this.filter.start = new moment(this.selected.date[0]).format('Y-MM-DD')
			this.filter.end = new moment(this.selected.date[1]).endOf('month').format('Y-MM-DD')
		},
		selectedType : function () {
			if(this.selectedType == 'Kecamatan')
				this.filter.dealer = null
			else
				this.filter.kecamatan = null

			this.filter.kabupaten = null
		},
		'filter.kabupaten' : function () {
			if(this.filter.kabupaten)
				this.loadKecamatan()
		}
	},
	mounted () {
		// this.loadKecamatan ()
		this.loadKabupaten()
	},
	methods : {
		exportExcel () {
			if(this.selectedType == 'Dealer')
				this.$refs.dealerMcd.exportExcel()
			else
				this.$refs.kecamatanMcd.exportExcel()
		},
		loadKecamatan () {
			this.$http.get(`/api/master/kecamatan?kabupaten=${this.filter.kabupaten}`)
			.then((resp) => {
				this.filterData.area = resp.data.data
			})
			.catch((err) => {
				console.log(err)
			})
		},
		loadKabupaten () {
			this.$http.get('/api/master/kabupaten')
			.then((resp) => {
				this.filterData.kabupaten = resp.data.data
				console.log(resp.data.data)
			})
			.catch((err)=> {
				console.log(err)
			})
		}
	}
}
</script>

<style scoped>
	.text-red {
		color : red;
	}
	.text-green {
		color : green;
	}

	.btn-primary {
		background-color : #ff9700;
		border-color: #ff9700;
	}
	.btn-outline-primary {
		border-color: #ff9700;
		color : #ff9700;
	}

	h4 {
		color : #707070;
	}
</style>

<style>
	.datePickerMCD .el-input__icon {
		margin-top : -1px;
	}
</style>